var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "add-cargo-form",
      attrs: {
        visible: _vm.visible,
        title: "加入货物",
        "destroy-on-close": "",
        width: "1000px"
      },
      on: { close: _vm.onClose }
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            "label-width": "50px",
            "label-position": "top"
          }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { staticStyle: { "margin-top": "0" }, attrs: { span: 20 } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "供应商", prop: "supplierId" } },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "select-type":
                                    _vm.TYPE_NAMES.basic_data_Company,
                                  filterable: "",
                                  "default-value": _vm.form.supplierId || "",
                                  "tag-name": "chineseName",
                                  "method-params": { tradersSign: true }
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.form.supplierId = p.value)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "生产商", prop: "producerId" } },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "select-type":
                                    _vm.TYPE_NAMES.basic_data_Company,
                                  filterable: "",
                                  "default-value": _vm.form.producerId || "",
                                  "tag-name": "chineseName",
                                  "method-params": { factorySign: true }
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.form.producerId = p.value)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "来源", prop: "source" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.source,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "source", $$v)
                                  },
                                  expression: "form.source"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "起运港", prop: "pol" } },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "select-type":
                                    _vm.TYPE_NAMES.basic_data_Seaport,
                                  filterable: "",
                                  "default-value": _vm.form.pol
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.form.pol = p.value)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "目的港", prop: "pod" } },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "select-type":
                                    _vm.TYPE_NAMES.basic_data_Seaport,
                                  filterable: "",
                                  "default-value": _vm.form.pod
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.form.pod = p.value)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "预计货好时间",
                                prop: "estimatedIncomeDate"
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: { type: "daterange", clearable: "" },
                                model: {
                                  value: _vm.form.estimatedIncomeDate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "estimatedIncomeDate",
                                      $$v
                                    )
                                  },
                                  expression: "form.estimatedIncomeDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "订单号", prop: "poNos" } },
                            [
                              _c("cargo-multi-line-text-popover", {
                                ref: "poInput",
                                attrs: {
                                  "input-width": "100%",
                                  value: _vm.form.poNos,
                                  "show-popover": "",
                                  "visible-arrow": true
                                },
                                on: {
                                  "update:value": function($event) {
                                    return _vm.$set(_vm.form, "poNos", $event)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "SKU号", prop: "itemNo" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.itemNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "itemNo", $$v)
                                  },
                                  expression: "form.itemNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "包装创建日期",
                                prop: "createDate"
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: { type: "daterange", clearable: "" },
                                model: {
                                  value: _vm.form.createDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "createDate", $$v)
                                  },
                                  expression: "form.createDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { "label-width": "0" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.handleQuery(1)
                            }
                          }
                        },
                        [_vm._v("搜索")]
                      ),
                      _c("el-button", { on: { click: _vm.handleImport } }, [
                        _vm._v("导入")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { display: "flex" } },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", "min-height": "300px" },
            attrs: {
              "show-side-bar": false,
              "grid-options": _vm.gridOptions,
              "row-data": _vm.rowData,
              "column-defs": _vm.columnDefs
            },
            on: {
              gridReady: function(params) {
                return (_vm.gridOptions.columnApi = params.api)
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "el-form",
            [
              _c("cargo-pagination", {
                attrs: {
                  total: _vm.filter.total,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize,
                  "page-sizes": [10, 20, 30, 50, 100, 200, 500]
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: function() {
                    return _vm.handleQuery()
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }